module.exports = __webpack_public_path__ + "static/img/strona_047.08256cee.jpg";